import type { StatusMap } from "@vixio/ui";

export const LEVEL: StatusMap = {
  baixo: { label: "baixo", tone: "ok" },
  moderado: { label: "moderado", tone: "info" },
  alto: { label: "alto", tone: "warn" },
  critico: { label: "crítico", tone: "crit" },
};
export const CATEGORY: Record<string, string> = {
  comercial: "Comercial", capacidade: "Capacidade", juridico: "Jurídico", institucional: "Institucional", reputacao: "Reputação", lgpd: "LGPD",
  financeiro: "Financeiro", operacao: "Operação",
};
export const PROBABILITY: Record<number, string> = { 1: "Rara", 2: "Improvável", 3: "Possível", 4: "Provável", 5: "Quase certa" };
export const IMPACT: Record<number, string> = { 1: "Insignificante", 2: "Menor", 3: "Moderado", 4: "Maior", 5: "Grave" };

/** Faixas de `risks.level_of`: 1–4 baixo, 5–9 moderado, 10–14 alto, 15–25 crítico. */
export function levelOf(score: number): "baixo" | "moderado" | "alto" | "critico" {
  return score >= 15 ? "critico" : score >= 10 ? "alto" : score >= 5 ? "moderado" : "baixo";
}

export interface RiskView {
  id: string;
  code: string;
  title: string;
  category: string;
  description: string;
  source_ref: string | null;
  warning_signal: string;
  mitigation: string;
  owner_person_id: string | null;
  owner_name: string | null;
  probability: number;
  impact: number;
  score: number;
  level: string;
  status: "ativo" | "encerrado";
  review_every_days: number;
  next_review_on: string;
  days_to_review: number | null;
  review_overdue: boolean;
  last_assessed_at: string | null;
  assessments: number;
  last_delta: number | null;
}

export interface MatrixCell {
  probability: number;
  impact: number;
  score: number;
  level: string;
  risks: number;
  codes: string[];
}

export interface Assessment {
  id: string;
  kind: "inicial" | "revisao";
  probability: number;
  impact: number;
  score: number;
  previous_score: number | null;
  signal_observed: boolean;
  notes: string | null;
  created_at: string;
}

type U = string;
declare module "@vixio/data" {
  interface RpcRegistry {
    "risks.upsert_risk": {
      args: {
        p_org: U; p_code: string; p_title: string; p_category: string; p_description: string; p_warning_signal: string; p_mitigation: string; p_probability: number; p_impact: number;
        p_owner_person?: U | null; p_owner_label?: string | null; p_review_every_days?: number; p_source_ref?: string | null;
      };
      returns: U;
    };
    "risks.assess": {
      args: { p_risk: U; p_probability: number; p_impact: number; p_notes?: string | null; p_signal_observed?: boolean; p_idempotency_key?: string | null };
      returns: { assessment_id: U; previous_score: number; score: number; level: string; escalated: boolean; idempotent: boolean };
    };
    "risks.close_risk": { args: { p_risk: U; p_reason: string }; returns: null };
    "risks.reopen_risk": { args: { p_risk: U }; returns: null };
  }
}
